import { Sparkles, Star, Moon, Sun, Leaf, Rocket, Heart, Bird, Flower2, Cat, Compass, Feather } from "lucide-react";

export const PROFILE_AVATARS = [
  { key: "spark", Icon: Sparkles },
  { key: "star", Icon: Star },
  { key: "moon", Icon: Moon },
  { key: "sun", Icon: Sun },
  { key: "leaf", Icon: Leaf },
  { key: "rocket", Icon: Rocket },
  { key: "heart", Icon: Heart },
  { key: "bird", Icon: Bird },
  { key: "flower", Icon: Flower2 },
  { key: "cat", Icon: Cat },
  { key: "compass", Icon: Compass },
  { key: "feather", Icon: Feather },
];

export const PROFILE_COLORS = [
  { key: "amber", ring: "from-amber-300 to-orange-500", glow: "hsl(38 95% 55% / 0.45)", text: "text-amber-200" },
  { key: "emerald", ring: "from-emerald-300 to-teal-500", glow: "hsl(160 70% 45% / 0.45)", text: "text-emerald-200" },
  { key: "sky", ring: "from-sky-300 to-indigo-500", glow: "hsl(210 90% 55% / 0.45)", text: "text-sky-200" },
  { key: "rose", ring: "from-rose-300 to-pink-500", glow: "hsl(340 85% 60% / 0.45)", text: "text-rose-200" },
  { key: "violet", ring: "from-violet-300 to-purple-500", glow: "hsl(270 80% 60% / 0.45)", text: "text-violet-200" },
  { key: "lime", ring: "from-lime-300 to-green-500", glow: "hsl(90 70% 50% / 0.45)", text: "text-lime-200" },
];

export const avatarFor = (key) => (PROFILE_AVATARS.find((a) => a.key === key) || PROFILE_AVATARS[0]).Icon;
export const colorFor = (key) => PROFILE_COLORS.find((c) => c.key === key) || PROFILE_COLORS[0];
